import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {ApiService} from '@drl/core/api/api.service';
import {Observable} from 'rxjs';
import {FetchPAIntensityLogsCommand, FetchPAOverviewLogsCommand, FetchPATrendLogsCommand} from '../commands';
import {PhysicalActivityIntensityChartDto, PhysicalActivityOverviewChartDto, PhysicalActivityTrendChartDto, PhysicalActivityWeekChartDto} from '../models';

@Injectable()
export class PhysicalActivityFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
  ) {}

  getLogsByPatientId(
    patientId: number,
    month?: number,
    year?: number,
  ): Observable<PhysicalActivityOverviewChartDto | PhysicalActivityWeekChartDto> {
    const command: FetchPAOverviewLogsCommand<PhysicalActivityOverviewChartDto | PhysicalActivityWeekChartDto> =
      new FetchPAOverviewLogsCommand(this.apiService, this.anyAdapter, patientId);

    if (month && year) {
      let params = new HttpParams();
      params = params.set('month', `${month}`);
      params = params.set('year', `${year}`);

      command.parameters = {
        query: params,
      };
    }
    return command.execute();
  }

  getPhysicalActivitiyTrendChartLogs(
    patientId: number,
    type: string,
    start: string,
    end: string
  ): Observable<PhysicalActivityTrendChartDto[]> {
    const command: FetchPATrendLogsCommand<PhysicalActivityTrendChartDto[]> =
      new FetchPATrendLogsCommand(this.apiService, this.anyAdapter, patientId, type);

      let params = new HttpParams();
      params = params.set('start', `${start}`);
      params = params.set('end', `${end}`);

      command.parameters = {
        query: params,
      };
    return command.execute();
  }

  getPhysicalActivitiyIntensityChartLogs(
    patientId: number,
    type: string,
    start: string,
    end: string
  ): Observable<PhysicalActivityIntensityChartDto[]> {
    const command: FetchPAIntensityLogsCommand<PhysicalActivityIntensityChartDto[]> =
      new FetchPAIntensityLogsCommand(this.apiService, this.anyAdapter, patientId, type);

      let params = new HttpParams();
      params = params.set('start', `${start}`);
      params = params.set('end', `${end}`);

      command.parameters = {
        query: params,
      };
    return command.execute();
  }
}
